<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="modal">
  <div class="modal-header">
    <h3>{{ 'add_azuga_driver_dialog.title' | translate }}</h3>
  </div>
  <div class="modal-body">
    <label>
      <span>{{ 'drivers.username' | translate }}</span>
      <input type="text" [(ngModel)]="username" [placeholder]="'add_azuga_driver_dialog.username_placeholder' | translate" [disabled]="submitting" />
    </label>

    <label>
      <span>{{ 'add_azuga_driver_dialog.driver_alias' | translate }}</span>
      <input type="text" [value]="driverAlias" disabled />
    </label>

    <label>
      <span>{{ 'add_azuga_driver_dialog.driver_name' | translate }}</span>
      <input type="text" [value]="driverName" disabled />
    </label>

    <label class="password-field">
      <span>{{ 'set_password_dialog.password' | translate }}</span>
      <div class="input-with-icon">
        <input [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" [placeholder]="'add_azuga_driver_dialog.password_placeholder' | translate" [disabled]="submitting" />
        <button type="button" class="icon-button" (click)="toggleShowPassword()" [attr.aria-label]="(showPassword ? 'set_password_dialog.hide' : 'set_password_dialog.show') | translate">
          <span class="material-symbols-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
        </button>
      </div>
    </label>

    <label>
      <span>{{ 'add_azuga_driver_dialog.language' | translate }}</span>
      <select [(ngModel)]="language" [disabled]="submitting">
        <option value="ES">ES</option>
        <option value="EN">EN</option>
      </select>
    </label>

    <label>
      <span>{{ 'edit_driver_data_dialog.truck_id' | translate }}</span>
      <input type="text" [(ngModel)]="truckId" [placeholder]="'edit_driver_data_dialog.truck_id_placeholder' | translate" [disabled]="submitting" />
    </label>

    <div class="error" *ngIf="error">{{ error }}</div>
  </div>
  <div class="modal-footer">
    <button class="button secondary" type="button" (click)="onCancel()" [disabled]="submitting">{{ 'edit_driver_data_dialog.cancel' | translate }}</button>
    <button class="button" type="button" (click)="onSubmit()" [disabled]="submitting">{{ 'edit_driver_data_dialog.continue' | translate }}</button>
  </div>
</div>
